// extracted by mini-css-extract-plugin
export default {"price":"k7-z","onSale":"l7-z","msrpLabelPrice":"m7-z","msrpLabel":"n7-z","originalPrice":"o7-z","percentOff":"p7-z"};